/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Amount_TitleInputs */

const en_admin_discounts_amount_title = /** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const de_admin_discounts_amount_title = /** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrag`)
};

const es_admin_discounts_amount_title = /** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe`)
};

const fr_admin_discounts_amount_title = /** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montant`)
};

/** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */
const it_admin_discounts_amount_title = en_admin_discounts_amount_title;

/** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */
const pt_br2_admin_discounts_amount_title = en_admin_discounts_amount_title;

/** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */
const pl_admin_discounts_amount_title = en_admin_discounts_amount_title;

/** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */
const hu_admin_discounts_amount_title = en_admin_discounts_amount_title;

/** @type {(inputs: Admin_Discounts_Amount_TitleInputs) => LocalizedString} */
const ro_admin_discounts_amount_title = en_admin_discounts_amount_title;

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Discounts_Amount_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_amount_title = /** @type {((inputs?: Admin_Discounts_Amount_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Amount_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_amount_title(inputs)
	if (locale === "de") return de_admin_discounts_amount_title(inputs)
	if (locale === "es") return es_admin_discounts_amount_title(inputs)
	if (locale === "fr") return fr_admin_discounts_amount_title(inputs)
	if (locale === "it") return it_admin_discounts_amount_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_amount_title(inputs)
	if (locale === "pl") return pl_admin_discounts_amount_title(inputs)
	if (locale === "hu") return hu_admin_discounts_amount_title(inputs)
	return ro_admin_discounts_amount_title(inputs)
});
export { admin_discounts_amount_title as "admin.discounts.amount_title" }